import { VonqOption, VonqTaxonomyLink } from "../../../types/vonqMapping";

export function linkToOption(
  link?: { vonqId?: number; description?: string } | null
): VonqOption | null {
  if (!link?.vonqId || !link.description) return null;
  return { id: Number(link.vonqId), name: String(link.description) };
}

export function optionToLink(option: VonqOption | null): VonqTaxonomyLink | undefined {
  if (!option) return undefined;
  return { vonqId: option.id, description: option.name };
}

/** Strip empty/null/undefined fragments from legacy comma-separated location strings. */
export function sanitizeLocationText(value?: string | null): string {
  if (!value?.trim()) return "";

  const parts = value
    .split(",")
    .map((part) => part.trim())
    .filter(
      (part) =>
        part &&
        part.toLowerCase() !== "null" &&
        part.toLowerCase() !== "undefined"
    );

  return parts.join(", ");
}
